// pt-BR translations for the GetPaid app shell. Full parity with shell.en.ts.
const shell: Record<string, string> = {
  // Cabeçalho / menu do usuário
  'shell.userMenu.open': 'Menu da conta',
  'shell.userMenu.addPasskey': 'Adicionar uma passkey',
  'shell.userMenu.signOut': 'Sair',
  'shell.signOut.confirm': 'Sair do GetPaid?',

  // Primitivos do assistente (Stepper / CopyableField)
  'shell.wizard.copy': 'Copiar',
  'shell.wizard.copied': 'Copiado',

  // Diálogo de configuração de passkey
  'shell.passkey.title': 'Passkeys',
  'shell.passkey.description':
    'Entre mais rápido da próxima vez usando seu dispositivo — digital, rosto ou bloqueio de tela. Sem senha para lembrar.',
  'shell.passkey.add': 'Adicionar uma passkey',
  'shell.passkey.adding': 'Configurando…',
  'shell.passkey.added': 'Passkey adicionada.',
  'shell.passkey.namePlaceholder': 'Este dispositivo',
  'shell.passkey.nameLabel': 'Nome (opcional)',
  'shell.passkey.listTitle': 'Suas passkeys',
  'shell.passkey.empty': 'Você ainda não tem passkeys.',
  'shell.passkey.loading': 'Carregando passkeys…',
  'shell.passkey.loadError': 'Não foi possível carregar suas passkeys. Tente novamente.',
  'shell.passkey.delete': 'Remover',
  'shell.passkey.deleting': 'Removendo…',
  'shell.passkey.deleted': 'Passkey removida.',
  'shell.passkey.deleteConfirm': 'Remover esta passkey?',
  'shell.passkey.unnamed': 'Passkey sem nome',
  'shell.passkey.createdAt': 'Adicionada em {date}',
  'shell.passkey.lastUsed': 'Usada por último em {date}',
  'shell.passkey.neverUsed': 'Nunca usada',
  'shell.passkey.unsupported':
    'Este dispositivo ou navegador não suporta passkeys. Tente outro dispositivo.',
  'shell.passkey.error': 'Não foi possível configurar a passkey. Tente novamente.',
  'shell.passkey.close': 'Fechar',
};

export default shell;
